export class SelfAssessmentDetailHistory {

    assessmentDetails: Array<ItemDetailList>;
    reviewDetails: Array<ItemDetailList>;
    overallConclusion: Array<ItemDetailList>;
    gapDescription: Array<ItemDetailList>;
    remediationAction: Array<ItemDetailList>;
    closureRationale: Array<ItemDetailList>;
    enhancementDescription: Array<ItemDetailList>;
    enhancementAction: Array<ItemDetailList>;

    constructor() {
        this.assessmentDetails = [];
        this.reviewDetails = [];
        this.overallConclusion = [];
        this.gapDescription = [];
        this.remediationAction = [];
        this.closureRationale = [];
        this.enhancementDescription = [];
        this.enhancementAction = [];
    }
}

export class ItemDetailList {
    itemTitle: string;
    createdOn: Date;

    constructor() {
        this.itemTitle = '';
        this.createdOn = new Date();
    }
}

export class SelfAssessmentT2DetailHistory{
    assessmentDetails: Array<ItemDetailList>;
    reviewDetails: Array<ItemDetailList>;
    enhancementDescription: Array<ItemDetailList>;
    interpretationDetails:Array<ItemDetailList>;
    judgementDetails:Array<ItemDetailList>;
    gapDetail:Array<ItemDetailList>;
    approvalComment:Array<ItemDetailList>;

    constructor() {
        this.assessmentDetails = [];
        this.reviewDetails = [];
        this.enhancementDescription = [];
        this.interpretationDetails = [];
        this.judgementDetails = [];
        this.gapDetail = [];
        this.approvalComment = [];
    }
}
